/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Container, Grid, Stack, Tab, Tabs } from '@mui/material'
import React, { useEffect, useState } from 'react'
// eslint-disable-next-line import/no-unresolved
import Actionbutton from 'src/components/Actionbutton'

// eslint-disable-next-line import/no-unresolved

// eslint-disable-next-line arrow-body-style

import { useNavigate, useParams } from 'react-router-dom';

import EditErrorData from './Edit';
import DeleteModel from '../../components/Deletemodle'
import Overview from './Overview';

// eslint-disable-next-line arrow-body-style
import { apidelete, apiget } from '../../service/api';
import Header from '../../components/Header';
import { CustomTabPanel, a11yProps } from '../../components/CustomTabPanel';

const View = () => {

    const [errorData, setErrorData] = useState({});
    const [userAction, setUserAction] = useState(null);
    const [openEdit, setOpenEdit] = useState(false);
    const [opendelete, setOpendelete] = useState(false);
    const [value, setValue] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate()
    const params = useParams()

    // open Edit model
    const handleOpenEdit = () => setOpenEdit(true);
    const handleCloseEdit = () => setOpenEdit(false);

    // open delete model
    const handleOpenDelete = () => setOpendelete(true);
    const handleCloseDelete = () => setOpendelete(false);

    // tab
    const handleChange = (event, newValue) => setValue(newValue);

    // fetch api
    const fetchdata = async () => {
        setIsLoading(true)
        try {
            const result = await apiget(`api/errors/view/${params.id}`);
            if (result && result.status === 200) {
                setErrorData(result?.data?.result);
            }
        } catch (error) {
            console.error("Error fetching error data:", error);
        }
        setIsLoading(false)
    };


    // delete api
    const deletedata = async () => {
        await apidelete(`api/errors/delete/${params.id}`)
        navigate('/dashboard/systemerrors')
    }

    useEffect(() => {
        fetchdata();
    }, [userAction])

    return (
        <div>
            {/* open Edit errors Model */}
            <EditErrorData open={openEdit} handleClose={handleCloseEdit} setUserAction={setUserAction} errorData={errorData} fetchError={fetchdata} />

            {/* open Delete mode */}
            <DeleteModel opendelete={opendelete} handleClosedelete={handleCloseDelete} deletedata={deletedata} id={params.id} />

            <Container maxWidth>
                <Grid container display="flex" alignItems="center">
                    <Stack direction="row" alignItems="center" mb={3} justifyContent={"space-between"} width={"100%"}>
                        <Header
                            title="Error Details"
                        />
                        <Stack direction="row" alignItems="center" justifyContent={"flex-end"} spacing={2}>
                            {/* Action Butoon */}
                            <Actionbutton
                                handleOpenEdit={handleOpenEdit}
                                handleOpenDelete={handleOpenDelete}
                                back={() => navigate(-1)}
                            />
                        </Stack>
                    </Stack>
                </Grid>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: "0px" }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="OVERVIEW" {...a11yProps(0)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        <Overview data={errorData} setUserAction={setUserAction} isLoading={isLoading} />
                    </CustomTabPanel>
                </Box>
            </Container>
        </div>
    )
}

export default View
